import f from "./internal/_curry3.mjs";
import m from "./internal/_has.mjs";
import c from "./internal/_isInteger.mjs";
import n from "./internal/_assoc.mjs";
import a from "./isNil.mjs";
var g = /* @__PURE__ */ f(function e(r, t, o) {
  if (r.length === 0)
    return t;
  var i = r[0];
  if (r.length > 1) {
    var s = !a(o) && m(i, o) && typeof o[i] == "object" ? o[i] : c(r[1]) ? [] : {};
    t = e(Array.prototype.slice.call(r, 1), t, s);
  }
  return n(i, t, o);
});
export {
  g as default
};
